import React from "react";
import PropTypes from "prop-types";
import { usePromiseTracker } from "react-promise-tracker";
import { PulseLoader } from 'react-spinners';
import { CSSTransition } from 'react-transition-group';
import "./loading-overlay.scss";

const LoadingOverlay = props => {
    let params = props.area === null ? { delay: 100 } : { delay: 100, area: props.area };
    let minDuration = props.minDuration ?? 300;
    const { promiseInProgress } = usePromiseTracker(params);
    let name = 'loading-spinner-wrapper'
    if (props.pptx_action_panel == true && props.docArray.length == 0) {
        name = 'loading-spinner-wrapper-pptx-action-panel'
    }

    return (
        <CSSTransition
            in={promiseInProgress}
            timeout={minDuration}
            classNames="loading-overlay"
            onEnter={props.onEnter}
            onEntering={props.onEntering}
            onEntered={props.onEntered}
            onExit={props.onExit}
            onExited={props.onExited}
            unmountOnExit
        >
            <React.Fragment>
                {
                    (
                        <div className="loading-overlay" area={props.area}>
                            <div className={name} style={props.location}>
                                <PulseLoader className="loading-spinner"></PulseLoader>
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        </CSSTransition>
    )
};

LoadingOverlay.propTypes = {
    area: PropTypes.string,
    minDuration: PropTypes.number,
    pptx_action_panel: PropTypes.bool,
    docArray: PropTypes.array,
    onEnter: PropTypes.func,
    onEntering: PropTypes.func,
    onEntered: PropTypes.func,
    onExit: PropTypes.func,
    onExited: PropTypes.func,
    location: PropTypes.object
};

export default LoadingOverlay;
